import { render, staticRenderFns } from "./previewTemplate.vue?vue&type=template&id=553c047c&"
import script from "./previewTemplate.vue?vue&type=script&lang=js&"
export * from "./previewTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports